// plugins/offline.client.ts
export default defineNuxtPlugin(() => {
	const { init } = useOffline()
	init()
})
